<template>
  <div class="out">
    <banner />
    <div class="stickybar">
      <a :style="nowindex===1 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">产品简介</a>
      <a :style="nowindex===2 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">功能介绍</a>
      <a :style="nowindex===3 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">产品优点</a>
      <a :style="nowindex===4 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">优秀实践</a>
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text">
          <h3
            style="font-weight: bolder;color: rgb(37, 108, 255);">睿泽智慧电表</h3>
          <p class="big_des"><br>睿泽智慧电表基于物联网关键技术开发，通过电表远程操控，实时计量，租户缴费监控等功能，为物业住房管理提供可视化，实时化，自动化的综合能源管理手段。</p>
          <img src="../assets/electric.png" style="padding-top:80px">
        </div>
      </div>
    </div>
    <div class="wow bounceInLeft review" data-wow-duration="1s" data-wow-delay="0s" style="margin-left: 0; margin-right: 0;">
      <div class="title">
        <div class="top-text" style="padding-top:0">
          <h2 id="myh2" class="rikc">顺应市场形势</h2>
          <ul class="jn_lisyc" style="visibility: visible;">
            <li>
              <img class="fl" src="../assets/qz1.jpg" alt="">
              <div class="fl content">
                <dd>节能提效应</dd>
                <dt>节能提效应为我国能源战略之首，合理实施能耗双控考核体系。</dt>
              </div>
            </li>
            <li>
              <img class="fl" src="../assets/qz2.jpg" alt="">
              <div class="fl content">
                <dd>推进数字化改革</dd>
                <dt>推进数字化改革，加快建设数字经济核心产业。</dt>
              </div>
            </li>
            <li>
              <img class="fl" src="../assets/qz3.jpg" alt="">
              <div class="fl content">
                <dd>碳中和数字经济发展</dd>
                <dt>碳中和数字经济发展，掀起一场绿色革命。</dt>
              </div>
            </li>
            <li>
              <img class="fl" src="../assets/qz4.jpg" alt="">
              <div class="fl content">
                <dd>推进中国能源结构调整</dd>
                <dt>推进中国能源结构调整，引导传统计量数字化转型。</dt>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="parttwo" ref="partii" class="function-wrap wow bounceInUp " data-wow-duration="1s" data-wow-delay="0s">
      <div class="function-box">
        <p class="h1">五大功能，高效提升电能管理效率</p>
        <ul class="function-content">
          <li>
            <i class="function-1"/>
            <p class="title1">远程抄表</p>
            <p class="detail">
              实时获取各电表数据<br >
              监控电表状态
            </p>
          </li>
          <li>
            <i class="function-2"/>
            <p class="title1">远程拉合闸</p>
            <p class="detail">
              管理平台手动操作<br >
              缴费情况自动拉闸
            </p>
          </li>
          <li>
            <i class="function-3"/>
            <p class="title1">缴费情况监控</p>
            <p class="detail">欠缴提醒<br>缴费明细</p>
          </li>
          <li>
            <i class="function-4"/>
            <p class="title1">房源管理</p>
            <p class="detail">房源信息查询<br>房源关联电表</p>
          </li>
          <li>
            <i class="function-5"/>
            <p class="title1">住户管理</p>
            <p class="detail">住户详情查询<br>住户绑定房源</p>
          </li>
          <li>
            <i class="function-6"/>
            <p class="title1">更多功能</p>
            <p class="detail">敬请期待......</p>
          </li>
        </ul>
      </div>
    </div>
    <div id="partthree" ref="partiii" class="gc_ceng gc_ceng_four wow bounceInLeft" data-wow-duration="1s" data-wow-delay="0s">
      <div class="ceng_thin">
        <div class="ceng_title">睿泽智慧电表的优势</div>
        <div class="ceng_decro"/>
        <div class="ceng_box">
          <div>
            <div>
              <img alt="" src="@/assets/qq1.png" width="150px" lazy="loaded">
            </div>
            <p>能源可视化<br>为用户提供直观<br>的电能用量图</p>
          </div>
          <div>
            <div style="box-shadow:0 0 0 0; background: transparent">
            <img alt="" src="@/assets/qq2.png" width="200px" height="200px" margin-left="100px" lazy="loaded"></div>
            <p>控制自动化<br>用量缴费智能检测<br>电表自动化管理</p>
          </div>
          <div>
            <div>
              <img alt="" src="@/assets/qq3.png" width="140px" lazy="loaded">
            </div>
            <p>安装运维:安装简单<br>即装即用，免调校;<br> 零维护，运维更轻松。</p>
          </div>
          <!-- <div>
                <div>
                    <img alt="" src="../assets/logo.png" width="150px" lazy="loaded">
                </div>
                <p>Lorem, ipsum dolor.<br>Lorem, ipsum dolor.<br>Lorem, ipsum dolor.</p>
            </div> -->
        </div>
      </div>
    </div>
    <div id="partfour" class="customer_success">
      <cs-btm title="苏州市吴中区农业农村局：“三资系统”智慧电表上线" desc="苏州吴中区农业农村局联合睿泽构建“智慧电表”智能化功能，可线上对企业电表进行全方位监控，包含用电量、电表读数等，可实现自动拉闸或者人工拉闸等功能。" />
    </div>
    <CircleBtn @back="back" />
  </div>
</template>

<script>
import CsBtm from './CsBtm.vue'
import Banner from '@/views/products/components/Banner'
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'Electricity',
  components: { CsBtm, Banner, CircleBtn },
  data() {
    return {
      nowindex: 1,
      partI: false,
      partII: false,
      partIII: false,
      partIV: false,
      style1: '',
      style2: '',
      style3: '',
      style4: '',
      itemShow: 'first',
      imgarray: [
        { title: 'img1', url: 'https://picsum.photos/1024/480/?image=52', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' },
        { title: 'img2', url: 'https://picsum.photos/1024/480/?image=54', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' },
        { title: 'img3', url: 'https://picsum.photos/1024/480/?image=58', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' },
        { title: 'img4', url: 'https://picsum.photos/1024/480/?image=55', text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo deleniti dicta fuga minima qui excepturi consequatur pariatur nisi voluptatem consectetur enim, voluptate eos, obcaecati, iusto repellendus tenetur doloremque sequi libero.' }
      ]
    }
  },
  mounted() {
  },
  methods: {
    jump: function(x) {
      this.nowindex = x
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

.top-text {
  padding: 10% 0 8% 0;
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}
.stickybar a {
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
li {
  list-style-type: none;
}
.function-wrap {
  width: 100%;
  /* height: 890px; */
  position: relative;
  background: url(~@/assets/function_bg.jpg) 50% 50% no-repeat;
  background-size: cover;
  /* -ms-behavior: url(css/backgroundsize.min.htc);
  behavior: url(css/backgroundsize.min.htc); */
}
.function-box {
  width: 1210px;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.function-box > p.h1 {
  font-size: 32px;
  color: #fff;
  text-align: center;
  line-height: 1;
  padding: 70px 0 130px;
}
.function-content {
  width: 100%;
  position: relative;
}
.function-content li {
  position: relative;
  width: 350px;
  height: 250px;
  float: left;
  margin-left: 40px;
  background: #fff;
  border-radius: 5px;
  margin-bottom: 70px;
}
.function-content li:first-child,
.function-content li:first-child + li + li + li {
  margin-left: 0px;
}
.function-content li:first-child + li + li + li + li + li + li {
  margin-left: 0px;
}
.function-content li p.title1 {
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #292929;
  padding: 100px 0 30px;
}
.function-content li p.detail {
  text-align: center;
  line-height: 180%;
  font-size: 14px;
  color: #7f7f7f;
}
.function-content li i {
  display: block;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: -50px;
}
.function-content li i.function-1 {
  background: url(../assets/function_1.png) no-repeat 50% 50%;
}
.function-content li i.function-2 {
  background: url(../assets/function_2.png) no-repeat 50% 50%;
}
.function-content li i.function-3 {
  background: url(../assets/function_3.png) no-repeat 50% 50%;
}
.function-content li i.function-4 {
  background: url(../assets/function_4.png) no-repeat 50% 50%;
}
.function-content li i.function-5 {
  background: url(../assets/function_5.png) no-repeat 50% 50%;
}
.function-content li i.function-6 {
  background: url(../assets/function_6.png) no-repeat 50% 50%;
}

.gc_ceng.gc_ceng_four {
    padding: 70px 0 70px 0;
    background: #fff;
    background: url(~@/assets/products-bg.714f810.png)
}

.gc_ceng .ceng_thin {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    text-align: left;
}

.gc_ceng .ceng_thin .ceng_title {
    font-size: 32px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 40px;
    margin: 0 0 20px;
    text-align: center;
}

.gc_ceng .ceng_thin .ceng_decro {
    font-size: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #666;
    line-height: 15px;
    margin: 0 0 70px;
    text-align: center;
}

.gc_ceng.gc_ceng_four .ceng_box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.gc_ceng.gc_ceng_four .ceng_box>div {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 180px;
    flex: 0 0 180px;
    margin: 0 0 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.gc_ceng.gc_ceng_four .ceng_box>div>div {
    width: 180px;
    height: 180px;
    margin: 0 0 40px;
    background: #fff;
    -webkit-box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    border-radius: 50%;
}

.gc_ceng.gc_ceng_four .ceng_box>div>p {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 34px;
}
.gc_ceng.gc_ceng_four .ceng_box>div>div>img {
    /* max-width: 100%; */
    max-height: 100%;
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
}

.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}

#partfour {
  background: rgba(234,239,243,1);
}

.practice h1{
  padding: 50px 0 50px 0;
}

.practice img {
  padding: 50px 0 50px 0;
}

#solutiontext {
  color:whitesmoke;
  padding-bottom: 30px;
}

.solutionList {
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  background-color: #000413;
}

.solutionContent {
  display: flex;
  padding-top: 30px;
}

.solutionList h4 {
  margin: 0;
}

.leftList {
  width: 400px;
}

.listItem {
  padding: 20px 100px 20px 100px;
  background-color: #000413;
}

.leftItem p{
  color: whitesmoke;
  text-align: left;
  padding: 2%;
}

.leftItem {
  display: flex;
  margin:5px;
  padding:3px;
  background: linear-gradient(to right,rgba(64, 224, 208, 1), rgba(64, 224, 208, 0));
}

/* .rightContent {
  background: url(../assets/solution3-1.97f0170.png);
  width:780px;
  height: 600px;
  margin: auto;
}

.rightContent p {
  color:whitesmoke;
  text-align:left;
} */

#review2 {
  background: url(../assets/solution-bg.2000a70.png) no-repeat 50%;
}

#myh2 {
  background: url(../assets/sqc.png) no-repeat 50% 50%
}

.jn_lisyc li {
    width: 48%;
    float: left;
    margin-right: 4%;
    margin-bottom: 16px;
    height: 114px;
}

.jn_lisyc li:nth-of-type(2n) {
    margin-right: 0;
}

.jn_lisyc {
    overflow: hidden;
}

.fl {
    float: left;
}

.content {
    width: 400px;
    margin-left: 48px;
}

dd {
    margin-bottom: .5rem;
    margin-left: 0;
}

.content dd {
    font-size: 22px;
    color: #333333;
}

.rikc {
    margin: 50px auto;
}
</style>>



// WEBPACK FOOTER //
// src/components/electricity.vue